/**
 * 将外域图片地址改写为当前站同源代理路径，配合 Nginx 反代，避免 HTTPS 页 Mixed Content。
 *
 * http://xwd.888jn.cn/a.jpg
 *   → /proxy-888jn/a.jpg
 *     → https://xwd.juneng.yun/proxy-888jn/a.jpg
 *
 * https://crm-xwd.oss-cn-beijing.aliyuncs.com/b.jpg
 *   → /proxy-oss/b.jpg
 *     → https://xwd.juneng.yun/proxy-oss/b.jpg
 */
const PROXY_HOST_MAP = [{
	hosts: ['xwd.888jn.cn'],
	prefix: '/proxy-888jn'
}, {
	hosts: ['crm-xwd.oss-cn-beijing.aliyuncs.com'],
	prefix: '/proxy-oss'
}]

export function normalizeResourceUrl(url) {
	if (!url || typeof url !== 'string') {
		return ''
	}
	let result = url.trim()
	if (!result) {
		return ''
	}

	// //cdn.example.com/a.jpg
	if (result.startsWith('//')) {
		const protocol = (typeof window !== 'undefined' && window.location.protocol) ? window.location.protocol : 'https:'
		result = protocol + result
	}

	if (!/^https?:\/\//i.test(result)) {
		return result
	}

	try {
		const parsed = new URL(result)
		const host = (parsed.hostname || '').toLowerCase()
		const matched = PROXY_HOST_MAP.find(item => item.hosts.includes(host))
		if (matched) {
			return `${matched.prefix}${parsed.pathname || '/'}${parsed.search || ''}${parsed.hash || ''}`
		}
		// 其它 http 资源在 https 页面升 https
		if (typeof window !== 'undefined' && window.location.protocol === 'https:' && parsed.protocol === 'http:') {
			parsed.protocol = 'https:'
			return parsed.toString()
		}
		return result
	} catch (e) {
		return result
	}
}

export default normalizeResourceUrl
